
        var result = require("!!../../node_modules/raw-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./user-info.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/components/user-info.component.scss
// module id = 14
// module chunks = 0